import dotsTopLeft from "../images/doubts.png";
import dotsBottomRight from "../images/remov-bg-dots.png";
import headerimage from "../images/headerImg.png";
import step1Img from "../images/step1.png";
import step2Img from "../images/step2.png";
import step3Img from "../images/step3.png";
import success1 from "../images/success1.png";
import success2 from "../images/success2.png";
import success3 from "../images/success3.png";
import success4 from "../images/success4.png";
import Testimonials from "./testimonial";
import Form from "./form";

// ====== DATA: Timeline cards ======
const timelineSteps = [
  {
    img: step1Img,
    alt: "Kickstart your journey",
    title: "Kickstart your journey",
    titleClass: "text-lg md:text-xl font-bold text-[#2A3342]",
    text: "Start with our online assessment, receive a personalized medication plan, and book a consultation with one of our expert dietitians.",
  },
  {
    img: step2Img,
    alt: "Shed up to 10% of your weight",
    title: "Shed up to 10% of your weight",
    titleClass: "text-lg md:text-xl font-bold text-[#2A3342]",
    text: "Revamp your eating habits, boost your energy and mood, enjoy dose adjustments when needed, and benefit from regular follow-ups with our medical team for a personalized experience.",
  },
  {
    img: step3Img,
    alt: "Embrace a whole new lifestyle",
    title: "Embrace a whole new lifestyle!",
    // third card ka original class different tha, isliye yahan customize kiya
    titleClass: "text-[20px] font-bold text-[#2A3342]",
    text: "These steps are designed to enhance your well-being and help you embrace a fresh, energizing way of living.",
  },
];

// ====== DATA: Success story cards ======
const successImages = [success1, success2, success3, success4];

const treainJection = () => {
  return (
    <>
      <div className="font-poppins ">
        {/* ========== Section 1 ========== */}
        <section className="relative bg-white py-14 md:py-20 font-poppins">
          <img
            src={dotsTopLeft}
            alt="dots"
            className=" absolute left-[42px] -translate-x-1/2 top-[1px] w-16 sm:w-20 opacity-80 pointer-events-none select-none "
          />
          <img
            src={dotsBottomRight}
            alt=""
            className="hidden md:block absolute bottom-4 right-4 sm:w-20 lg:w-20 pointer-events-none select-none"
          />

          <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
            <h1
              className="font-black tracking-[-0.02em] text-[#2A3342] leading-[60px] 
              text-[24px] md:text-[42px] lg:text-[60px]"
            >
              Weight Loss Injections
            </h1>

            <p className="mt-6 text-[16px] leading-relaxed text-[#2A3342]">
              Slimming Doctor is one of the most affordable weight loss clinics in
              London. Your treatment programme which includes regular consultations
              with the doctor, meal plan and prescription-only medications (appetite
              suppressants) costs less than a price of coffee with us. It could as
              low as £2.38 per day!!! Slimming Doctor does not tie you in a
              contract and you are free to leave the programme at any time. There
              are no other hidden or surprise costs – and that&apos;s our promise to
              you.
            </p>
          </div>
        </section>

        {/* ============ Section 2 ============ */}
        <section className="bg-[#FAFAFA] py-14 md:py-20 overflow-x-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
              <div className="w-full md:w-[45%] flex justify-center md:justify-start">
                <img
                  src={headerimage}
                  alt="Doctor"
                  className="w-full rounded object-cover"
                />
              </div>

              <div className="w-full md:flex-1 text-left">
                <h2 className="text-[48px] font-bold text-[#2A3342] mb-4">
                  Doctor Led Care
                </h2>

                <p className="text-[16px] leading-relaxed text-[#2A3342] max-w-xl">
                  We offer both Mounjaro and Wegovy injections in a variety of doses.
                  Our programmes also contain expert advice on healthy diet,
                  movement and mindset so your health improves as you lose weight.
                </p>

                <h3 className="mt-6 text-[24px] font-bold text-[#2A3342]">
                  Easy and safe to use
                </h3>

                <p className="mt-2 text-[16px] text-[#2A3342] leading-relaxed max-w-xl">
                  Our weight loss injections are self-administered on a weekly basis.
                  They come in the form of a self-injectable pens which is really
                  easy and painless to use. 58% Our injections are designed to help
                  suppress appetite, making it easier for you to stick to your
                  dietary plan and resist unhealthy temptations. With reduced
                  cravings, you&apos;ll find it simpler to make healthier food choices
                  and stay on track towards your weight loss goals.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============= Section 3 ============ */}
        <section className="py-16 md:py-20 font-poppins overflow-x-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-[48px] font-bold text-center text-[#2A3342] mb-10 md:mb-12">
              Your Weight Loss Timeline
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {timelineSteps.map((step, index) => (
                <div
                  key={index}
                  className="bg-white rounded border border-[#E5E7EB] shadow-md p-3"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      src={step.img}
                      alt={step.alt}
                      className="w-full h-70 object-cover"
                    />
                  </div>

                  <div className="mt-5 px-2">
                    <h3 className={step.titleClass}>{step.title}</h3>
                    <p className="mt-2 text-sm md:text-[15px] leading-relaxed text-[#2A3342]">
                      {step.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* =========== Section 4 ============== */}
        <section className="bg-[#FAFAFA] py-16 md:py-20 font-poppins overflow-x-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-10 md:mb-12">
              <h2 className="text-[48px] font-bold text-[#2A3342]">
                Success stories
              </h2>

              <div className="flex items-center gap-3">
                <button
                  type="button"
                  className="w-10 h-10 rounded-full bg-[#35C3D9] flex items-center justify-center shadow-md"
                >
                  <span className="text-white text-lg leading-none">&lt;</span>
                </button>
                <button
                  type="button"
                  className="w-10 h-10 rounded-full bg-[#35C3D9] flex items-center justify-center shadow-md"
                >
                  <span className="text-white text-lg leading-none">&gt;</span>
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ">
              {successImages.map((imgSrc, index) => (
                <div
                  key={index}
                  className="bg-white rounded border border-[#E5E7EB] shadow-sm p-3"
                >
                  <div className="overflow-hidden rounded">
                    <img
                      src={imgSrc}
                      alt="Before and after"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="mt-3 flex items-center justify-between px-2 font-semibold">
                    <span className="text-[14px] md:text-sm text-[#2A3342]">
                      Before
                    </span>
                    <span className="text-[14px] md:text-sm text-[#2A3342]">
                      After
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>

      <Testimonials />
      <Form />
    </>
  );
};

export default treainJection;